// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */
const DescriptionsItem = _ref => {
  let {
    children
  } = _ref;
  return children;
};
export default DescriptionsItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/descriptions/Item.js
// module id = 1883
// module chunks = 0